"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const router_service_g_1 = require("./router-service.g");
class RouterService extends router_service_g_1.RouterService {
    /**
     * Constructor with parameters to support various environments. You can manage your own default persistance layer for token management by passing in an implementation of the StorageAsync interface. You can provide your own http implementation see here https://github.com/qubyte/fetch-ponyfill.
     * @constructor
     * @param {string} params.version For targeting a specific version
     * @param {string} params.cloud For targeting a specific cloud
     * @param {string} params.stage For targeting a specific stage
     * @param {string} params.url For targeting a specific url.  Overrides version, cloud, and stage.
     * @param {HttpMethod} params.http Supply custom http instance
     * @param {NotificationsService} params.notify Supply custom notify instance
     */
    constructor(params = {}) {
        params.version = params.version || '2018-03-03';
        super(params);
    }
}
exports.RouterService = RouterService;
//# sourceMappingURL=router-service.js.map